/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('email-access-gate')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class EmailAccessGate extends Modal {
      constructor() {
        super();
        this.cookie = 'email-access-gate-submitted';
        this.successMessage = this.querySelector('[data-email-gate-success]');

        if (this.successMessage) {
          this.markSubmitted();
          return;
        }

        if (this.dataset.forceOpen === 'true') {
          this.open();
        } else if (!getCookie(this.cookie)) {
          this.open();
        }
      }

      /**
       * Opens the modal without allowing Escape to close it.
       * @param {Element} opener - Modal opener element.
       */
      open(opener) {
        super.open(opener);
        this.removeEventListener('keyup', this.keyupHandler);
      }

      /**
       * Prevents closing via backdrop clicks.
       * @param {object} evt - Event object.
       */
      handleClick() {
        // Non-closable: ignore backdrop and close button clicks.
      }

      /**
       * Persists submission and closes the modal.
       */
      markSubmitted() {
        setCookie(this.cookie, true, Number(this.dataset.cookieDays) || 365);
        this.close();
      }

      /**
       * Closes the modal without persisting submission.
       */
      close() {
        super.close();
      }
    }

    customElements.define('email-access-gate', EmailAccessGate);
  });
}
